import createEntree from 'onyx-common/createEntree'

const createPreheatEntree = (payload) => {
  const { preheatEntree } = createEntree(payload)

  return preheatEntree
}

export default createPreheatEntree
